import { render, staticRenderFns } from "./createQuestionnaireModal.vue?vue&type=template&id=04aaf3fa&scoped=true"
import script from "./createQuestionnaireModal.vue?vue&type=script&lang=js"
export * from "./createQuestionnaireModal.vue?vue&type=script&lang=js"
import style0 from "./createQuestionnaireModal.vue?vue&type=style&index=0&id=04aaf3fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04aaf3fa",
  null
  
)

export default component.exports